import { z } from 'zod';

/**
 * F36 — assignment of a club trainer to a club-managed team (D9: a team may
 * have multiple assigned trainers; a trainer may manage many teams). The
 * assignment (not the team captain role) grants management authority over the
 * team's schedule / attendance / friendlies, gated by `hasClubTeamPermission`.
 */

export const TEAM_TRAINER_STATUS_VALUES = ['active', 'removed'] as const;
export type TeamTrainerStatus = (typeof TEAM_TRAINER_STATUS_VALUES)[number];

export type TeamTrainer = {
  readonly id: string;
  readonly teamId: string;
  readonly trainerUserId: string;
  readonly b2bAccountId: string;
  readonly assignedByUserId: string | null;
  readonly status: TeamTrainerStatus;
  readonly assignedAt: string;
  readonly removedAt: string | null;
  readonly countryCode: string;
  readonly createdAt: string;
  readonly updatedAt: string;
};

/** Enriched row for the team-detail "assigned trainers" list. */
export type TeamTrainerView = TeamTrainer & {
  readonly trainerDisplayName: string;
};

/** POST /me/club/teams/:teamId/trainers — assign a club trainer to a team. */
export const AssignTeamTrainerInputSchema = z.object({ trainerUserId: z.string().uuid() }).strict();
export type AssignTeamTrainerInput = z.infer<typeof AssignTeamTrainerInputSchema>;
